export default {"src":"/_next/static/media/world-icon-white.7273122d.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};